import { ChevronRight, KeyboardArrowDown } from '@mui/icons-material';
import { SimpleTreeView } from '@mui/x-tree-view';
import { SettingsTreeNode, SettingsNodeProps } from './settings-tree-node.component';

export interface SettingsTreeProps {
  title: string;
  root: SettingsNodeProps;
  selectedNodeId?: string;
  expandedNodeIds: string[];
  onToggleNode: (nodeIds: string[]) => void;
}

function EmptyIcon() {
  return <div style={{ width: 18 }} />;
}

export function SettingsTree(props: SettingsTreeProps) {
  const handleSelect = () => {
    // Do nothing.
    // The selection is triggered by a separate click event.
    // We are passing a noop function to override the default behavior.
  };

  return (
    <SimpleTreeView
      slots={{
        expandIcon: ChevronRight,
        collapseIcon: KeyboardArrowDown,
        endIcon: EmptyIcon
      }}
      slotProps={{
        expandIcon: { style: { maxHeight: 18, maxWidth: 18 } },
        collapseIcon: { style: { maxHeight: 18, maxWidth: 18 } }
      }}
      expandedItems={props.expandedNodeIds}
      selectedItems={props.selectedNodeId}
      onExpandedItemsChange={(_, itemIds) => props.onToggleNode(itemIds)}
      onItemSelectionToggle={handleSelect}
    >
      <SettingsTreeNode {...props.root} />
    </SimpleTreeView>
  );
}
